<template>
    <div class="page-class">
        <div class="page-wrapper">
            <div id="invite_content"
                class="page-content page-container">
                <div >
                    <NavBar :isShowBack="true" :pageName="lbl.get_friend.invite_title" @clickBack="clickBack">

                    </NavBar>
                    <div id="invite_info" class="invite">
                        <FriendGetFriend></FriendGetFriend>
                        <div class="text-stroke-white text-center text-medium-green mt-3 mb-0" :text="lbl.get_friend.invite_txt_point">{{ lbl.get_friend.invite_txt_point }}</div>
                        <div class="text-stroke-white text-center text-medium-small" :text="lbl.get_friend.invite_txt_max_ppl">{{ lbl.get_friend.invite_txt_max_ppl }}</div>

                    </div>
                    <div id="invite_block">
                        <div id="invite_block_wrapper">
                            <img id="invite_block_img" class="img-fluid" src="../../../assets/bg/bg-getfriend-invite.svg" />

                        </div>
                    </div>
                </div>
                <div class="btn-block">
                    <div id="invite_btn"
                            :class="{'invite-disable': !isLine}">
                            <div class="btn-ic">
                                <img src="../../../assets/icon/icon-line-active.svg" v-if="isLine" />
                                <img src="../../../assets/icon/icon_line_disable.svg" v-else />
                            </div>
                            <div class="btn-txt"
                                @click="clickInvite()">{{lbl.get_friend.invite_btn}}</div>
                        </div>
                </div>
            </div>
        </div>
        <!-- <cookie-consent-bar></cookie-consent-bar> -->
        <ModalMaster :controller="modalController" :theme="userType" />
    </div>
</template>
<script>
//helper
import LineFunction from '@/helper/facede/LineFunction.js';
import Util from "@/helper/Utility.js";
import Locale from '@/helper/locale/locale.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//core
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
// import CookieConsentBar from '@/components/Layout/CookieConsentBar/CookieConsentBar.vue';
import NavBar from '../../../components/Layout/NavBar/NavBar.vue';
import FriendGetFriend from '../component/friendgetfriend/FriendGetFriend.vue';
//service
import GetFriendService from "@/core/GetFriend/service/GetFriendService.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
export default {
    name: 'InviteFriend',
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin],
    components: {
        ModalMaster,
        // CookieConsentBar,
        NavBar,
        FriendGetFriend
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            isLoading: false,
            lbl: Locale.getLbl(),
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),

            trackingService: new TrackingService(this),
            trackingScreenName: 'friendgetfriend',
            trackingEventCategory: 'fgf_page',
        };
    },
    created: function () {
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);

        //error
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.modalController.alertModal);

        this.trackingService.screenName(this.trackingScreenName);
    },
    methods: {
        //mixin
        accountInitiated: function () {

        },
        //event
        clickBack: function () {
            this.$router.back();
            this.trackingService.event(this.trackingEventCategory, 'click_back', null, null);
        },
        clickInvite: async function () {
            if (!this.isLine) return;

            let linkShare = await this.getLinkFriendGetFriend();
            if (Util.isEmptyStr(linkShare)) return;

            let line = new LineFunction();
            let liffId = line.getLiffId();
            line.init(liffId).then(() => {
                line.shareTextToFriends(linkShare).then((data) => {
                    // success
                    console.log(data);
                }).catch((err) => {
                    console.log(err);
                });
            });

            this.trackingService.event(this.trackingEventCategory, 'click_invite_friend', null, null)
        },
        //method
        getLinkFriendGetFriend: async function () {
            return new Promise((resolve) => {
                let token = this.getToken();
                GetFriendService.getFriendLink(token).then((link) => {
                    console.log(link);
                    resolve(link);
                }).catch((err) => {
                    this.errorResponse(err, this.errorHandler);
                    resolve(null);
                })
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '../style/getFriend.scss';
</style>
